import React, { useEffect, useMemo, useState } from "react"
import { Container, Button } from "reactstrap"
import { message, notification, Select } from "antd"
import "react-quill/dist/quill.snow.css"
import JoditEditor from "jodit-react"

import Loader from "./Loader"
import Breadcrumbs from "components/Common/Breadcrumb"
import { usePermissionData } from "AppContext"
import { axiosbaseurl } from "../config"
import PermittedComponent from "PermittedComponent"
import { MdSend } from "react-icons/md"
import { SiTicktick } from "react-icons/si"
import { IoMdWarning } from "react-icons/io"

const DailyTrades = () => {
  const [Loading, setLoading] = useState(false)
  const [CustomerData, setCustomerData] = useState([])
  const [Selected, setSelected] = useState([])
  const [EditorContent, setEditorContent] = useState("")
  const { checkAccess } = usePermissionData()

  const editor_config = useMemo(
    () => ({
      readonly: false,
      height: 300,
      askBeforePasteHTML: false,
      placeholder: "",
    }),
    []
  )

  useEffect(() => {
    getData()
  }, [])

  async function getData() {
    setLoading(true)
    try {
      const response = await axiosbaseurl.get(`customer-management`)
      if (response?.data?.success) {
        // Convert to format AntD Select accepts
        const options = response.data.data
          .sort((a, b) => {
            const idA = a.clientId?.toString().toLowerCase() || ""
            const idB = b.clientId?.toString().toLowerCase() || ""
            return idA.localeCompare(idB, undefined, { numeric: true })
          })
          .map(c => ({
            label: `(${c.clientId}) ${c.name || c.customerName || "Unnamed"}`,
            value: c._id || c.id,
          }))

        setCustomerData(options)
      }
    } catch (e) {
      console.log("Error", e.response?.data?.message)
    } finally {
      setLoading(false)
    }
  }

  const [error, setError] = useState({
    selected: "",
    content: "",
  })

  const validateForm = ({ selected, content }) => {
    const errors = {}

    if (!selected || selected.length === 0) {
      errors.selected = "Please select at least one customer."
    }

    const cleanedContent = content?.replace(/<(.|\n)*?>/g, "").trim() // Strip HTML
    if (!cleanedContent) {
      errors.content = "Please enter daily trade content."
    }

    return errors
  }

  const handleSend = async () => {
    const formErrors = validateForm({
      selected: Selected,
      content: EditorContent,
    })

    if (Object.keys(formErrors).length > 0) {
      setError(formErrors)
      return
    }

    setError({}) // Clear previous errors

    try {
      setLoading(true)

      const payload = {
        customerIds: Selected,
        message: EditorContent,
      }

      const response = await axiosbaseurl.post(
        "/customer-management/send/daily-trades",
        payload
      )
      if (response?.data?.success === true) {
        setLoading(false)
        notification.open({
          message: (
            <div className="d-flex align-items-center">
              <div className="pr-20">
                <SiTicktick className="text-success fs-4 me-2" />
              </div>
              <div className="succes-message">
                Daily Trades Sent SuccessFully.
              </div>
            </div>
          ),
          placement: "topRight",
        })
        setSelected([])
        setEditorContent("")
      } else {
        setLoading(false)
        notification.open({
          message: (
            <div className="d-flex">
              <div className="pr-10">
                <IoMdWarning className="text-danger" size={22} />
              </div>
              <div>Opps! Something went wrong.</div>
            </div>
          ),
        })
      }
    } catch (e) {
      notification.open({
        message: (
          <div className="d-flex">
            <div className="pr-10">
              <IoMdWarning className="text-danger" size={22} />
            </div>
            <div>Opps! Something went wrong.</div>
          </div>
        ),
        description: e?.response?.data?.message,
      })
    } finally {
      setLoading(false)
    }
  }

  return (
    <React.Fragment>
      {Loading && <Loader />}
      <PermittedComponent isAccess={checkAccess(11, 1)}>
        <div className="page-content">
          <Container fluid>
            <Breadcrumbs title="" breadcrumbItem="Daily Trades" />
            <div className="card p-3">
              {/* Multi-select */}
              <div className="mb-3">
                <label>
                  <strong>Select Customers</strong>
                </label>
                <Select
                  mode="multiple"
                  className="Antd-select"
                  allowClear
                  placeholder="Select customers"
                  style={{ width: "100%", height: "50px" }}
                  value={Selected}
                  options={CustomerData}
                  onChange={setSelected}
                />
                {error?.selected && (
                  <span className="text-danger mt-1">{error?.selected}</span>
                )}
              </div>

              {/* Editor */}
              <div className="mb-3">
                <label>
                  <strong>Trade Content</strong>
                </label>
                <JoditEditor
                  value={EditorContent}
                  config={editor_config}
                  askBeforePasteFromHTML={false}
                  onChange={newContent => {
                    setEditorContent(newContent)
                  }}
                />
                {error?.content && (
                  <span className="text-danger mt-1">{error?.content}</span>
                )}
              </div>

              {/* Send Button */}
              <div className="text-end">
                <Button color="primary" onClick={handleSend}>
                  <MdSend className="me-1" /> Send Daily Trades
                </Button>
              </div>
            </div>
          </Container>
        </div>
      </PermittedComponent>
    </React.Fragment>
  )
}

export default DailyTrades
